"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initPerf = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * performance timing 数据
 */

var fix = function fix(t) {
  return Math.min(1e5, Math.max(parseInt(t.toString(), 10), 0));
};
var getData = function getData() {
  var _window;
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = (params === null || params === void 0 ? void 0 : params.backup) || {},
    fmp = _ref.fmp;
  var result = {
    blankTime: 0,
    // 白屏时长
    rdStartTime: 0,
    rdEndTime: 0,
    fStartTime: 0,
    cStartTime: 0,
    cEndTime: 0,
    dnsStartTime: 0,
    dnsEndTime: 0,
    dnsTime: 0,
    fpTime: 0,
    fpEndTime: 0,
    domStartTime: 0,
    // firstPiantTime: 0, // 该参数放到 resource 文件中计算
    readyTime: 0,
    atfStartTime: 0,
    domLoadedTime: 0,
    atfTime: 0,
    // 首屏时间
    activeTime: 0,
    loadTime: 0,
    // 完全加载时间
    webviewInitTime: 0,
    domInteractiveTime: 0
  };
  var ptiming = performance.timing;
  // 白屏时间
  result.blankTime = fix(ptiming.responseStart - ptiming.navigationStart);
  // 重定向开始
  result.rdStartTime = fix(ptiming.redirectStart - ptiming.navigationStart);
  // 重定向结束
  result.rdEndTime = fix(ptiming.redirectEnd - ptiming.navigationStart);
  // 浏览器发起请求的时间
  result.fStartTime = fix(ptiming.fetchStart - ptiming.navigationStart);
  // connect开始
  result.cStartTime = fix(ptiming.connectStart - ptiming.navigationStart);
  // connect结束
  result.cEndTime = fix(ptiming.connectEnd - ptiming.navigationStart);
  // dns开始时间
  result.dnsStartTime = fix(ptiming.domainLookupStart - ptiming.navigationStart);
  // dns结束时间
  result.dnsEndTime = fix(ptiming.domainLookupEnd - ptiming.navigationStart);
  // dns耗时
  result.dnsTime = fix(ptiming.domainLookupEnd - ptiming.domainLookupStart);
  // 浏览器开始接受数据的时间，首包时间,即ttf时间, 浏览器收到从服务端（或缓存，本地资源）响应回的第一个字节的数据的时刻
  result.fpTime = fix(ptiming.responseStart - ptiming.navigationStart);
  // http请求耗时
  result.fpEndTime = fix(ptiming.responseEnd - ptiming.navigationStart);
  // 开始解析收到的 HTML 页面的第一个字节。
  result.domStartTime = fix(ptiming.domLoading - ptiming.navigationStart);
  // 完成所有 script 加载和解析之后, 当 DOMContentLoaded 事件触发之前，浏览器完成所有script（包括设置了defer的script）的下载和解析之后的时刻
  // result.domContentLoadedEventStart = fix(ptiming.domContentLoadedEventStart - ptiming.navigationStart)
  // document 文档解析完成，不包括异步js，即 readyState 变为'interactive'，readystartechange触发，指文档解析完成的时刻，包括在“传统模式”下被阻塞的通过script标签加载的内容（除了使用defer或者async属性异步加载的情况）
  // 文档已被解析，"正在加载" 状态结束, DOM 元素可以被访问, 但是诸如图像，样式表和框架之类的子资源仍在加载
  result.domInteractiveTime = fix(ptiming.domInteractive - ptiming.navigationStart);
  // dom 完全构建包括样式
  result.domLoadedTime = fix(ptiming.domContentLoadedEventStart - ptiming.navigationStart);
  // domReady 时间 ，SSR 项目首屏时间
  result.readyTime = fix(ptiming.domContentLoadedEventEnd - ptiming.navigationStart);
  if (!result.atfStartTime) result.atfStartTime = result.readyTime;
  // 可操作时间，包括使用图片，document.readyState 属性设置为 "complete" 与 onload 近似
  result.activeTime = fix(ptiming.domComplete - ptiming.navigationStart);
  // _ZZ_WEBVIEW_CREATE_TIME_  该变量为客户端 webview 注入
  if ((_window = window) !== null && _window !== void 0 && _window._ZZ_WEBVIEW_CREATE_TIME_) {
    var _window2;
    result.webviewInitTime = fix(ptiming.navigationStart - +((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2._ZZ_WEBVIEW_CREATE_TIME_));
    result.blankTime = fix(result.blankTime + result.webviewInitTime);
  }
  result.loadTime = Math.max(fix(ptiming.loadEventEnd - ptiming.navigationStart), fmp ? fmp + 100 : 0);
  if (result.loadTime !== 0) {
    result.atfTime = fmp || result.loadTime;
  } else {
    result.atfTime = result.activeTime;
  }
  return result;
};
var initPerf = function initPerf() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var performance = window.performance;
  if (!(performance !== null && performance !== void 0 && performance.timing)) return params;
  var res = getData(params);
  Object.assign(params.backup, _objectSpread({}, res));
  return params;
};
exports.initPerf = initPerf;